// extracted by mini-css-extract-plugin
export default {"nav":"Navbar_nav__ABpzh","logo":"Navbar_logo__L5PTy","buttons":"Navbar_buttons__GoP1L","btn":"Navbar_btn__h85PY","img":"Navbar_img__0pZOU","text":"Navbar_text__-15W5"};